import { action, makeObservable, observable } from "mobx";
import { BarChartProps } from "../../../../../../core/charts/BarChart/BarChart";

export class ActionSummaryChartModel {
  organisationId: number;
  @observable isLoading: boolean = true;
  projectId: number;
  loadDataFn: (organisationId: number, projectId: number) => Promise<any>;
  @observable chartData: BarChartProps;
  transformer: (data: any[]) => BarChartProps;

  /**
   *
   */
  constructor(
    organisationId: number,
    projectId: number,
    loadDataFn: (organisationId: number, projectId: number) => Promise<any>,
    transformer: (data: any[]) => BarChartProps
  ) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.loadDataFn = loadDataFn;
    this.transformer = transformer;
  }

  onMount = () => {
    this.loadChartData();
  };

  loadChartData = async () => {
    let res = await this.loadDataFn(this.organisationId, this.projectId);
    this.setChartData(res.payload);
  };

  @action
  setChartData = (data: any[]) => {
    this.chartData = this.transformer(data);
    this.isLoading = false;
  };
}
